export const appSettings = {
  api: {
    baseUrl: import.meta.env.VITE_APP_SCHOOL_DOMAIN === "ORIGIN" ? window.location.origin : import.meta.env.VITE_APP_SCHOOL_DOMAIN,
  },
  localization: {
    url: import.meta.env.VITE_APP_LOCALIZATION_URL,
  },
  aws: {
    cloudFront: import.meta.env.VITE_APP_AWS_CLOUD_FRONT,
    videoCloudFront: import.meta.env.VITE_APP_AWS_VIDEO_CLOUD_FRONT,
  },
  hub: {
    url: import.meta.env.VITE_APP_HUB_URL,
  },
  auth: {
    tokenUpdateIntervalInMins: import.meta.env
      .VITE_APP_TOKEN_UPDATE_INTERVAL_IN_MINS,
  },
  chat: {
    apiUrl: import.meta.env.VITE_APP_CHAT_API_URL,
    hubUrl: import.meta.env.VITE_APP_CHAT_HUB_URL,
  },
  quiz: {
    styleUrl: import.meta.env.VITE_APP_QUIZ_STYLE_URL,
    scriptUrl: import.meta.env.VITE_APP_QUIZ_SCRIPT_URL,
    apiUrl: import.meta.env.VITE_APP_QUIZ_API_URL,
  },
  checkout: {
    orderUrl: import.meta.env.VITE_APP_CHECKOUT_ORDER_URL,
    subscriptionUrl: import.meta.env.VITE_APP_CHECKOUT_SUBSCRIPTION_URL,
  },
  style: {
    logoSrc: import.meta.env.VITE_APP_STYLE_LOGO_SRC,
    poweredBy: {
      enabled: import.meta.env.VITE_APP_STYLE_LOGO_POWERED_BY_ENABLED,
      logoSrc: import.meta.env.VITE_APP_STYLE_LOGO_POWERED_BY_LOGO_SRC,
      href: import.meta.env.VITE_APP_STYLE_LOGO_POWERED_BY_HREF,
    },
  },
};
